import { render, staticRenderFns } from "./MyNews1.vue?vue&type=template&id=836e963e&scoped=true"
import script from "./MyNews1.vue?vue&type=script&lang=js"
export * from "./MyNews1.vue?vue&type=script&lang=js"
import style0 from "./MyNews1.vue?vue&type=style&index=0&id=836e963e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836e963e",
  null
  
)

export default component.exports